
const Day = (props: any) : JSX.Element => {
  return <></>
}
 

export default Day